import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardDescription, CardHeader, CardPoints, CardTitle } from './subcomponents';
var PropositionsCard = function (_a) {
    var heading = _a.heading, points = _a.points, description = _a.description;
    return (_jsxs(Card, { children: [_jsxs(CardHeader, { children: [_jsx(CardTitle, { children: heading }), _jsx(CardPoints, { children: points })] }), _jsx(CardDescription, { children: description })] }));
};
export default PropositionsCard;
